import { SPACE, THEME } from '../../../web/components-v2/Theme/theme';
import { FontFamilies } from '../../../web/styles/styles';
import { aidaBaseStyles } from '../../styles/styles';
import { StyleSheet } from 'aphrodite';

const { fontFamilies, fontSizes, fontWeights } = THEME.typography;

export const styleSheet = StyleSheet.create({
	basicPageContainer: {
		...aidaBaseStyles.flexCol,
		height: 'auto',
		margin: '0 auto',
		maxWidth: 1400,
		minHeight: '95%',
		paddingTop: 20,
	},
	body: {
		minWidth: '100%',
	},
	header: {
		...aidaBaseStyles.flexCenter,
		marginTop: SPACE[12],
		minWidth: '100%',
		position: 'relative',
		[THEME.queries.md]: {
			flexDirection: 'column',
			gap: SPACE[8],
		},
	},
	headerActions: {
		position: 'absolute',
		right: 0,
		top: '50%',
		transform: 'translateY(-50%)',
		[THEME.queries.md]: {
			position: 'static',
			transform: 'none',
		},
	},
	// Fills the scrolling body container edge to edge, covering the app's blue background under the page.
	lightBackdrop: {
		backgroundColor: THEME.colors.background.light,
		minHeight: '100%',
		width: '100%',
	},
	lightHeader: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		gap: SPACE[16],
		justifyContent: 'space-between',
		marginBottom: SPACE[24],
	},
	lightHeaderActions: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[12],
	},
	// Same box as the Call log page (16px page padding + 32px card padding), so the titles line up across Coffee.
	lightPage: {
		boxSizing: 'border-box',
		color: THEME.colors.text.main,
		fontFamily: fontFamilies.lexend,
		margin: '0 auto',
		maxWidth: 1400,
		padding: `${SPACE[48]}px ${SPACE[48]}px ${SPACE[32]}px`,
		width: '100%',
		[THEME.queries.sm]: {
			padding: SPACE[16],
		},
	},
	lightTitle: {
		color: THEME.colors.text.main,
		fontFamily: fontFamilies.sora,
		fontSize: fontSizes.xl,
		fontWeight: fontWeights.bold,
		margin: 0,
	},
	title: {
		color: '#fff',
		fontFamily: FontFamilies.conqueror,
		fontSize: 54,
		textTransform: 'uppercase',
	},
});
